<label class="box link">
    <img class="icon" [src]="icon">
    <p><ng-content></ng-content></p>
    <img class="arrow" src="/assets/spbfamily/arrow-Right.svg" alt="">
</label>